"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CloudinaryImage = _interopRequireDefault(require("../CloudinaryImage/CloudinaryImage"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var PoweredByGoogle = function PoweredByGoogle(_ref) {
  var className = _ref.className,
      cloudinary = _ref.cloudinary,
      cloudinaryImageId = _ref.cloudinaryImageId,
      imageWidth = _ref.imageWidth,
      imageHeight = _ref.imageHeight;
  var classes = (0, _classnames.default)('PoweredByGoogle', className);
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement(_CloudinaryImage.default, {
    className: "PoweredByGoogleImage",
    cloudinary: cloudinary,
    cloudinaryImageId: cloudinaryImageId,
    width: imageWidth,
    height: imageHeight
  }));
};

PoweredByGoogle.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The `cloudinary` object that attaches this image to a Cloudinary account. */
  cloudinary: _propTypes.default.object.isRequired,

  /** The image ID that is stored in Cloudinary for this image. */
  cloudinaryImageId: _propTypes.default.string.isRequired,

  /** The width to make the image transformation (typically half of the 2x source width for crisp images). */
  imageWidth: _propTypes.default.number,

  /** The height to make the image transformation (typically half of the 2x source height for crisp images). */
  imageHeight: _propTypes.default.number
};
PoweredByGoogle.defaultProps = {
  cloudinaryImageId: 'front-end/powered-by-google',
  imageWidth: 144,
  imageHeight: 18
};
var _default = PoweredByGoogle;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PoweredByGoogle, "PoweredByGoogle", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/GooglePlacesSearchInput/PoweredByGoogle.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/GooglePlacesSearchInput/PoweredByGoogle.jsx");
  leaveModule(module);
})();

;